module.exports = {
  en: {
    title: 'Secrets',
    subtitle: 'List of secrets.',
    form: {
      name: {
        hint: 'Create a name for your secret without spaces and underscores',
        placeholder: 'Enter a name as key like secret_name',
        error: 'Enter a valid name without special characters',
      },
      secret: {
        hint: 'This secret will be injected into the headers, parameters and body',
        placeholder: 'Enter a text string as secret, everything will be store as string.'
      },
      alert: 'For security reasons, secrets are not visible after creating or editing them',
      validation: 'You only can use underscore, no whitespaces'
    },
    columns: {
      traceId: 'Trace id',
      webhookId: 'Webhooks id',
    },
  },
  es: {
    title: 'Secretos',
    subtitle: 'Listado de secretos.',
    form: {
      name: {
        hint: 'Crea un nombre para tu secreto sin espacios ni guiones bajos',
        placeholder: 'Ingresa un nombre como clave, como secret_name',
        error: 'Ingresa un nombre válido sin caracteres especiales',
      },
      secret: {
        hint: 'Este secreto se inyectará en los encabezados, parámetros y cuerpo',
        placeholder: 'Ingresa una cadena de texto como secreto, todo se almacenará como cadena.'
      },
      alert: 'Por razones de seguridad, los secretos no son visibles después de crearlos o editarlos',
      validation: 'Solo puedes usar guiones bajos, no espacios en blanco'
    },
    columns: {
      traceId: 'Id de rastreo',
      webhookId: 'Id de webhooks',
    },
  },
  fr: {
    title: 'Secrets',
    subtitle: 'Liste des secrets.',
    form: {
      name: {
        hint: 'Créez un nom pour votre secret sans espaces ni tirets bas',
        placeholder: 'Entrez un nom comme clé, tel que secret_name',
        error: 'Entrez un nom valide sans caractères spéciaux',
      },
      secret: {
        hint: 'Ce secret sera injecté dans les en-têtes, les paramètres et le corps',
        placeholder: 'Entrez une chaîne de texte comme secret, tout sera stocké comme chaîne.'
      },
      alert: 'Pour des raisons de sécurité, les secrets ne sont pas visibles après leur création ou modification',
      validation: 'Vous ne pouvez utiliser que des tirets bas, pas d\'espaces'
    },
    columns: {
      traceId: 'Id de traçage',
      webhookId: 'Id des webhooks',
    },
}

};
